import { ContratacaoRotaInteligenteService } from './../../services/contratacao-rota-inteligente.service';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { BaseFormService } from 'src/app/services/base-form.service';
import { take } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { FilenameParser } from '@utils/FilenameParser';
import { FileDownloadService } from '@services/file-download.service';
import moment from 'moment';
import { LoadingGenericoComponent } from '../loading-generico/loading-generico.component';
import { CurrencyPipe } from '@angular/common';
@Component({
    selector: 'app-alert-confirmacao-contratacao-rota',
    templateUrl: './alert-confirmacao-contratacao-rota.component.html',
    styleUrls: ['./alert-confirmacao-contratacao-rota.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, CurrencyPipe]
})
export class AlertConfirmacaoContratacaoRotaComponent extends BaseFormService implements OnInit {

  @Input() alertAlterarEmpresa = false;
  @Input() consultaSelecionada: any;
  @Output() alertAlterarEmpresaFechou = new EventEmitter();
  @Output() checkPlano = new EventEmitter();

  public resources: any;
  public ipUsuario: any;
  public checkContrato = false;
  public idFaixa: any;
  public idContato: any = '';

  public loadingGenerico: any = false;
  public alertSucesso = false;
  public alertSucessoSubtitulo: any = 'Contratação realizada!';
  public alertSucessoMensagem: any = 'A contratação do seu plano mensal foi realizada com sucesso! ';

  public planoMensal: any = [];

  public data: any;
  public hora: any;
  public empresa: any = localStorage.idEmpresaLogada;

  public erro = false;
  public alertErroSubtitulo: any = 'Erro ao contratar o plano !';
  public alertErroMensagem = '';

  @Input() consultaAvulsa = false;
  @Input() consultaMensal = false;
  @Input() checkPlanoFiliais = false;

  constructor(
    private readonly contratacaoRotaInteligenteService: ContratacaoRotaInteligenteService,
    private readonly Toastr: ToastrService,
    private readonly router: Router
  ) { super();
  }

  ngOnInit(): void {
    this.getIpUsuario();
    this.RetornaDataHoraAtual();
    this.getPlanoMensal();
  }

  cancelarAlterarEmpresa() {
    this.alertAlterarEmpresa = false;
    this.alertAlterarEmpresaFechou.emit(this.alertAlterarEmpresa);
    this.checkContrato = false;
  }

  public getIpUsuario() {
    this.contratacaoRotaInteligenteService.getIpUsuario()
      .pipe(take(1))
      .subscribe({
        next: (sucess: any) => {
          this.ipUsuario = sucess.ip;
          this.getContrato();
        },
        error: () => {
          this.Toastr.error('Erro ao obter o IP do usuário. Por favor tente mais tarde.');
        }
      })
  }

  public getContrato() {
    this.contratacaoRotaInteligenteService.getContrato(this.empresa, this.ipUsuario)
      .pipe(take(1))
      .subscribe({
        next: (sucess: any) => {
          this.resources = sucess.response;
          if (this.consultaAvulsa) {
            this.alertSucessoMensagem = 'A contratação do seu plano avulso foi realizada com sucesso! ';
          } else {
            this.alertSucessoMensagem = 'A contratação do seu plano mensal foi realizada com sucesso! ';
          }
        },
        error: (error) => {
          console.error(error);
          if (error.error.mensagem) {
            this.Toastr.error(error.error.mensagem);
          } else {
            this.Toastr.error('Erro ao tentar obter os dados para o contrato. Por favor tente mais tarde.');
          }
          this.checkPlano.emit(true);
        }
      });
  }

  public getPlanoMensal() {
    this.contratacaoRotaInteligenteService.getAllPlanos(this.empresa)
      .pipe(take(1))
      .subscribe({
        next: (success: any) => {
          this.planoMensal = success.response.listaFaixas;
        },
        error: (error) => {
          this.Toastr.error('Erro ao fazer requisição');
        }
      })
  }

  private addZero(i) {
    if (i < 10) {
      i = '0' + i;
    }
    return i;
  }

  public RetornaDataHoraAtual() {
    const dNow = new Date();
    this.data = moment().format(`DD/MM/YYYY`);
    this.hora = dNow.getHours() + ':' + this.addZero(dNow.getMinutes());

  }

  public verificarContrato() {
    this.checkContrato = !this.checkContrato;
    this.getParamsFormatArray();

  }

  public getPlanoContratado() {
    this.loadingGenerico = true;
    const paramsArray = this.getParamsFormatArray();
    const paramsUrl = this.getParamsUrl(paramsArray);
    this.cancelarAlterarEmpresa();
    this.contratacaoRotaInteligenteService.getPlanoContratado(this.empresa, paramsUrl)
      .pipe(take(1))
      .subscribe({
        next: (success: any) => {
          this.loadingGenerico = false;
          this.alertSucesso = true;
          this.getDownloadContratado();
        },
        error: (error) => {
          this.erro = true;
          this.alertErroMensagem = error.error.mensagem;
          this.loadingGenerico = false;
        }
      });
  }

  public fecharAlertSucesso() {
    this.alertSucesso = false;
    this.router.navigate(['/contratacao-rota-inteligente']);
  }

  public fecharAlertErro() {
    this.erro = false;
    this.router.navigate(['/contratacao-rota-inteligente']);
  }

  public getParamsFormatArray() {
    this.getContrato();
    this.idFaixa = this.consultaSelecionada.idPlanoFaixa;

    const arr = [];

    arr.push(
      {name: 'rangeid', comparator: '=', value: this.idFaixa},
      {name: 'userip', comparator: '=', value: this.ipUsuario}
    );

    if (this.idContato != '') {
      arr.push({ name: 'contactid', comparator: '=', value: this.idContato });
    }

    if (this.checkPlanoFiliais) {
      arr.push({ name: 'replicatebranches', comparator: '=', value: this.checkPlanoFiliais });
    }

    return arr;
  }

  public getDownloadContratado() {

    const paramsArray = this.getParamsFormatArrayDownload();
    const paramsUrl = this.getParamsUrl(paramsArray);

    this.contratacaoRotaInteligenteService.getDownloadContrato(this.empresa, paramsUrl)
      .pipe(take(1))
      .subscribe({
        next: ({ body, headers }: HttpResponse<any>) => {
          const filename = FilenameParser.fromContentDispositionHeader(
            headers.get('content-disposition'),
            'Arquivo.csv',
          );
          FileDownloadService.download([body], filename);
        },
        error: () => {
        }
      });
  }

  public getParamsFormatArrayDownload() {
    this.getContrato();

    const arr = [];

    if (this.idContato != '') {

      arr.push({ name: 'contactid', comparator: '=', value: this.idContato });

    }

    return arr;
  }
}
